export default {
  "Connect Wallet": '链接钱包',
  "Loading":"加载中...",
  "Purchase Quantity": "购买数量",
  "Total Amount": "总额",
  "Payment Method": "支付方式",
  "Fee": "手续费",
  "Purchase": "购买",
  "Select Payment Method": "选择支付方式",
  "Language Switch": "语言切换",
  "Mall": "商城",
  "STAR Purchase": "STAR 购买",
  "Order Details": "订单详情",
  "My Orders": "我的订单",
  "Order Confirmation Page": "订单确认页",
  "Product Details": "商品详情",
  "Store Details": "店铺详情",
  "Staking MUSE":"质押MUSE",
  "My Stake":"我的质押",
  "Redeemable Time":"可赎回时间",
  "Redeem":"赎回",
  "Stake":"质押",
  "How to Obtain MUSE":"如何获取MUSE",
  "Activity Rules":"活动规则",
  "Stake Amount":"质押数量",
  "Please Enter Amount":"请输入数量",
  "Balance":"余额",
  "Redeem Amount":"赎回数量",
  "Confirm":"确认",
  "Cancel":"取消",
  "Staking MUSE can increase the voting power for activities on the StarNest platform, allowing you to vote for your favorite participants.":"质押MUSE，可以增加StarNest平台活动的投票数量，给你喜欢的选手进行投票。",
  "Rule1":"1.通过质押MUSE，增加StarNest平台活动的投票权重(参考对应活动说明)。",
  "Rule2":"2. 质押的MUSE在所投活动结束后可随时赎回。",
  "Rule3":"3. 质押MUSE，还可以参加平台治理与的其他活动。",
  "Rule4":"4. 最终解释权归StarNest平台。",
  "Staked":"已质押",
  "Redeemed":"已赎回",
  "Payment":"支付",
  "Next step":"下一步",
  "Amount":"金额",
  "Copied":"已复制",
  "QRCodeTip":"请扫描二维码或复制地址支付订单金额,如支付金额不足,则订单失败,且不退款.",
  "Scan QR code to pay":"扫描二维码支付",
  "DownloadTip":"扫码下载 StarNest App，立即体验",
  "Save QR code":"保存二维码",
  "Minimum":"最低",
  "All":"全部",
  "Failed to create order":"创建订单失败",
  "The order was created successfully and payment is being redirected":"创建订单成功，正在跳转支付",
  "Payment details":"支付详情",
  "Address management":"地址管理",
  "New address":"新建地址",
  "Delete address":"删除地址",
  "Are you sure you want to delete this address?":"确认删除该这个地址吗",
  "First name":"姓氏",
  "Last name":"名字",
  "Please enter":"请输入",
  "Phone":"手机号",
  "Country":"国家/地区",
  "State/Province":"洲/省",
  "City":"城市",
  "Address":"详细地址",
  "Zip code":"邮政编码",
  "Email":"邮箱",
  "Save address":"保存地址",
  "The address has been edited, do you want to save it?":"地址已编辑，是否保存",
  "Return":"返回",
  "Save":"保存",
  "Waiting for payment":"待付款",
  "Please complete the payment within time as soon as possible":"请尽快于{time}内完成付款",
  "Expired":"已过期",
  "Order ID":"订单ID",
  "Order total":"订单总额",
  "Order time":"订单时间",
  "Payment method":"支付方式",
  "Billing address":"账单地址",
  "Switch address":"切换地址",
  "Pay":"确认支付",
  "Deleted":"已删除",
  "Please fill in the form completely":"请完整填写表单",
  "Create success":"创建成功",
  "Update success":"修改成功",
  "Insufficient balance":"余额不足",
  "No address filled in yet":"暂未填写地址",
  "Choose country":"选择国家",
  "Please enter search keywords":"请输入搜索关键词",
  "Payment successful":"支付成功",
  "Please check the balance in your wallet":"请在钱包查看余额",
  "Finish":"完成",
  "Payment failed":"支付失败",
  "Please complete the payment in time in My Order-Waiting for Payment":"请在我的订单-待支付中及时完成支付",
  "Verification": '请完成安全验证',
  "Slide": '向右滑动完成验证',
  "Point": '请依次点击',
  "Verify success": '验证成功',
  "Verify fail": '验证失败',
  "Uploading":"上传中",
  "Upload payment voucher":"上传支付凭证",
  "Submission successful, please check the order later":"提交成功，請稍後查看訂單",
  "Confirm submission":"确认提交",
  "Detail":"详情",
  "Rate tip":"根据支付方式不同，票价可能存在汇率差异，以最终支付金额为准。",
  "Please log in":"请前往登陆",
  "Insufficient product inventory":"商品库存不足",
  "Showtime":"场次",
  "Ticket file":"票档",
  "Sold out":"售罄",
  "Limit tickets per order":"每笔订单限购{num}张",
  "Please select region":"请选择地区",
  "Please fill in the correct email address":"请填写准确的email地址",
  "Delivery method":"配送方式",
  "E-ticket":"电子票",
  "Direct entry":"直接入场",
  "After payment is successful, no need to pick up the ticket, go to the ticket folder to check the admission voucher":"支付成功后，无需取票，前往票夹查看入场凭证",
  "Contact person":"联系人",
  "Name":"姓名",
  "Please fill in the contact name":"请填写联系人姓名",
  "Region":"地区",
  "Please enter the mobile number":"请输入手机号",
  "Please fill in the email":"请填写邮箱",
  "The ticket verification code will be sent to your email via":"门票核销码将会通过电子邮件发送到您的邮箱中",
  "Details":"明细",
  "Submit order":"提交订单",
  "Price details":"价格明细",
  "The actual discount amount is subject to the following single page":"实际优惠金额以下单页为准",
  "Product information":"商品信息",
  "STAR deduction":"STAR抵扣",
  "Credit Card":"信用卡",
  "Payment Platform":"支付平台",
  "On-Chain Payment":"链上支付",
  "Other":"其他",
  "No refunds":"不支持退款",
  "Transferable":"可转赠",
  "Not transferable":"不可转赠",
  "Ended":"已结束",
  "Countdown":"倒计时",
  "Please select the ticket file":"请选择票档",
  "Insufficient commodity inventory":"商品库存不足",
  "Please go to log in":"请前往登陆",
  "what":"MUSE是什么？",
  "museIntro":"MUSE是发行在Armonia Meta Chain上的ARC20代币，发行总量21亿，80%的MUSE代币通过生态挖矿产出。",
  "museUse":"MUSE有什么用？",
  "copyrightStaking":"版权质押",
  "copyrightStaking1":"质押MUSE到合作艺人的版权（元宇宙AI、肖像、音视频等）NFT中，瓜分艺人版权收益。",
  "vote":"大赛投票",
  "vote1":"质押MUSE可获得STAR NEST WAR额外投票权，参与大赛各阶段投票。",
  "product":"产品购买",
  "product1":"用于购买生态内特殊产品，如艺人限量版NFT、限量周边、限量门票（早鸟票、VIP票等）。",
  "more":"更多玩法（持续更新）",
  "more1":"链游生态：合作链游经授权后可使用艺人版权，相关商品用MUSE付费。",
  "more2":"艺人支持：MUSE可用于打赏艺人与音乐创作者。",
  "activity":"特邀活动",
  "activity1":"获得特定活动的参加邀请。",
  "how":"MUSE如何获取？",
  "how1":"通过参与早期MUSE私募获取。",
  "how2":"通过作品创作，用户欣赏作品时主动激励。",
  "how3":"通过参与活动（如购票、商城消费、线下活动）获得空投。",
  "how4":"通过去中心化交易平台购买。",
}